import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IS_SUPER_ADMIN } from "../store/selectors";
import { PrivateRoute } from "./PrivateRoute";

interface SuperAdminRouteProps {
  children: JSX.Element;
}

/**
 * Route gate for "administradores principales" (SCRUM-706).
 *
 * Reads the flag straight from the store instead of re-running the auth
 * hydration: `auth/setAuth` writes `token` and `isSuperAdmin` together, and
 * PrivateRoute already sends anyone without a token to /login — so by the
 * time this renders its children the flag is the hydrated one, never a
 * pre-hydration `false`.
 *
 * This is UI gating only. The backend re-checks the flag against the database
 * on every /admin-access request (SuperAdminGuard).
 */
export const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
  const isSuperAdmin = useSelector(IS_SUPER_ADMIN);

  return (
    <PrivateRoute>
      {isSuperAdmin ? children : <Navigate to="/" replace />}
    </PrivateRoute>
  );
};
